import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { deleteRoutine, queryRoutines } from '@wix/ambassador-individual-scheduling-assistant-v1-routine/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { RoutinesClientBase } from './RoutinesClientBase';
export class RoutinesClient extends HttpBaseClient(RoutinesClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "queryRoutinesImpl", queryRoutines);
    _defineProperty(this, "deleteRoutineImpl", deleteRoutine);
  }
}
//# sourceMappingURL=RoutinesClientHttp.js.map